import { GraphQLResponse } from '@vend/types'
import { $http } from '../../ng-compat/imports'
import { RolesConnection } from '../../managers/user-manager'

/**
 * Service class for role related resources.
 *
 * @class RolesResourceService
 */
export class RolesResourceService {
  /**
   * Get all roles data
   *
   * @method getRoles
   *
   * @return {Promise} Resolved once the roles have been retrieved.
   */
  public getRoles() {
    const query = `
      query Roles {
        roles {
          roles {
            id
            name
            systemRoleID
            systemRoleName
            updatedAt
            position
            permissions {
              name
            }
            rules {
              name
              config
            }
          }
        }
      }`

    return $http
      .post<GraphQLResponse<RolesConnection>>('/api/graphql', {
        operationName: 'Roles',
        query,
      })
      .then(response => response.data.data.roles)
  }
}
